<template>
    <DCard>
        <DRow>
            <DCol>
                <DTable
                    :items="resellerProducts.items"
                    :fields="fields"
                >
                    <template #id="{item}">
                        <td>
                            <Link
                                v-if="userPermissions.includes('product.view')"
                                :href="$route('products.products.show', {product: item.product_id})"
                            >
                                {{ item.product_id }}
                            </Link>
                            <span
                                v-else
                                class="text-capitalize"
                            >{{ item.product_id }}</span>
                        </td>
                    </template>
                    <template #product_name="{item}">
                        <td>
                            <Link
                                v-if="userPermissions.includes('product.view')"
                                :href="$route('products.products.show', {product: item.product_id})"
                            >
                                {{ item.product_name }}
                            </Link>
                            <span
                                v-else
                                class="text-capitalize"
                            >{{ item.product_name }}</span>
                        </td>
                    </template>
                    <template #billing_product_plan_name="{item}">
                        <td>
                            <Link
                                v-if="userPermissions.includes('product.view')"
                                :href="$route('products.products.show', {product: item.product_id})"
                            >
                                {{ item.billing_product_plan_name }}
                            </Link>
                            <span
                                v-else
                                class="text-capitalize"
                            >{{ item.billing_product_plan_name }}</span>
                        </td>
                    </template>
                    <template #display_product_plan_name="{item}">
                        <td>
                            <Link
                                v-if="userPermissions.includes('product.view')"
                                :href="$route('products.products.show', {product: item.product_id})"
                            >
                                {{ item.display_product_plan_name }}
                            </Link>
                            <span
                                v-else
                                class="text-capitalize"
                            >{{ item.display_product_plan_name }}</span>
                        </td>
                    </template>
                    <template #actions="{item}">
                        <td>
                            <div style="display: flex; grid-gap: 10px;">
                                <DButton
                                    v-if="userPermissions.includes('customer.edit')"
                                    icon="pencil"
                                    mini
                                    @click="$inertia.get(edit(item.id))"
                                />
                                <DButton
                                    v-if="userPermissions.includes('customer.edit')"
                                    icon="trash-can-outline"
                                    color="danger"
                                    mini
                                    :disabled="isInLoadingState"
                                    @click="deleteReseller(item.id)"
                                />
                            </div>
                        </td>
                    </template>
                </DTable>
                <DPagination
                    v-if="resellerProducts.last_page > 1"
                    :active-page="resellerProducts.current_page"
                    :pages="resellerProducts.last_page"
                    align="center"
                    @update:activePage="changePage"
                />
            </DCol>
        </DRow>
        <DFabs>
            <s-s-o-fab
                :customer="customer"
                @open-modal="showCreateCloudpitCustomerModal = true"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
            <DFab
                v-if="userPermissions.includes('customer.edit')"
                icon="plus"
                :label="__('customers.reseller_products.add_product')"
                @click="$inertia.get($route('customers.customers.reseller-products.create', {customer: customer.id}))"
            />
        </DFabs>
        <DModal
            v-model:show="showConfirmationModal"
            :title="__('customers.reseller_products.deleteConfirmation.title')"
            :message="__('customers.reseller_products.deleteConfirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
        <CreateCloudPitCustomerModal
            :customer="customer"
            :show-modal="showCreateCloudpitCustomerModal"
            @close-modal="showCreateCloudpitCustomerModal = false"
        />
    </DCard>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'
import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'

export default {
    name: 'CustomerResellerProductsIndex',
    components: { CreateCloudPitCustomerModal, SSOFab },
    layout: [App, CustomerBase],
    props: {
        resellerProducts: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            fields: [
                { key: 'id', label: this.__('customers.common.id') },
                { key: 'product_name', label: this.__('customers.reseller_products.product_name') },
                { key: 'billing_product_plan_name', label: this.__('customers.reseller_products.billing_product_plan_name') },
                { key: 'display_product_plan_name', label: this.__('customers.reseller_products.display_product_plan_name') },
                { key: 'actions', label: '' }
            ],
            showConfirmationModal: false,
            deleteCallBack: () => { return {} },
            showCreateCloudpitCustomerModal: false
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        edit (id) {
            return this.$route('customers.customers.reseller-products.edit', {
                customer: this.customer.id,
                reseller_product: id
            })
        },
        deleteReseller (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(
                    this.$route('customers.customers.reseller-products.destroy', {
                        customer: this.customer.id,
                        reseller_product: id
                    }),
                    {
                        preserveScroll: true
                    }
                )
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        closeModal () {
            this.showConfirmationModal = false
            this.deleteCallBack = () => { return {} }
        },
        changePage (page) {
            const query = {}

            if (page > 1) {
                query.page = page
            }

            this.$inertia.get(this.$route('customers.customers.reseller-products.index', {
                customer: this.customer.id
            }), query)
        }
    }
}
</script>
